import { render, staticRenderFns } from "./titleease-order-tile.vue?vue&type=template&id=8bb706c8"
import script from "./titleease-order-tile.vue?vue&type=script&lang=js"
export * from "./titleease-order-tile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports